$(document).ready(function(){
  $("body").on("click", '#starke_btn', function(e){
    e.preventDefault();
  $(".starke-modal-popup-overlay").addClass("is-visible");
  $('html').addClass('modal-overflow');  
  });
  
  $("body").on("click", '#closeBtn', function(){
    $(".starke-modal-popup-overlay").removeClass("is-visible");
  });
  
  $("body").on("click", '#saure_btn', function(e){
    e.preventDefault();
  $(".saure-modal-popup-overlay").addClass("is-visible");
  });
  
  $("body").on("click", '#closeBtn', function(){
    $(".saure-modal-popup-overlay").removeClass("is-visible");
  });
  
  
  
  // according
  $('.toggle').click(function(e) {
    e.preventDefault();

    let $this = $(this);

    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find('li .inner').removeClass('show');
      $this.parent().parent().find('li .inner').slideUp(350);
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
    }
  });


  // variant switcher
  var optionselection = $('options-selection > fieldset').first().find('.swatch__option');
  var secondFieldset = $('options-selection > fieldset:nth-child(3)');
  var thirdFieldset = $('options-selection > fieldset:nth-child(4)');

  optionselection.each(function() {
      var singleOption = $(this);
      singleOption.click(function() {
          setTimeout(function() {
              secondFieldset.find('.swatch__option > input[data-variant-option-available=true]').first().click();
              thirdFieldset.find('.swatch__option > input').first().click();
          }, 500);    
      });
  });

  
});